import { render, staticRenderFns } from "./GitHubCorner.vue?vue&type=template&id=08d9f227&scoped=true&"
import script from "./GitHubCorner.vue?vue&type=script&lang=js&"
export * from "./GitHubCorner.vue?vue&type=script&lang=js&"
import style0 from "./GitHubCorner.vue?vue&type=style&index=0&id=08d9f227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9f227",
  null
  
)

component.options.__file = "GitHubCorner.vue"
export default component.exports